import React from 'react';

type TableBodyProps = React.ComponentProps<'tbody'>;

export const TableBody: React.FC<TableBodyProps> = ({ children, ...props }) => {
    return <tbody {...props}>{children}</tbody>;
};
